<template>
  <el-button style="margin-bottom: 15px; float: left;" type="primary" @click="dialogFormVisible = true">{{ $t('material.addmaterial', { msg: 'material.addmaterial' }) }}</el-button>
    <!-- <el-table
      :data="tableData"
      height="650"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        :label="$t('material.id', { msg: 'material.id' })"
        width="120">
      </el-table-column>
      <el-table-column
        prop="materialCode"
        :label="$t('material.materialcode', { msg: 'material.materialcode' })"
        width="280">
      </el-table-column>
      <el-table-column
        prop="material"
        :label="$t('material.material', { msg: 'material.material' })"
        width="280">
      </el-table-column>
      <el-table-column
        prop="materialPrice"
        :label="$t('material.materialprice', { msg: 'material.materialprice' })"
        width="150">
      </el-table-column>
      <el-table-column
        prop="unit"
        :label="$t('material.unit', { msg: 'material.unit' })"
        width="200">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        :label="$t('craft.updateTime', { msg: 'craft.updateTime' })"
        width="280">
      </el-table-column>
      <el-table-column :label="$t('kbReview.table.opr', { msg: 'kbReview.table.opr' })" width="320" v-if="isAdmin">
            <template #default="scope">
                <el-button
                    size="mini"
                    type="primary" 
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row)">{{  $t('kbType.update', { msg: 'kbType.update' }) }}</el-button>
                <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index, scope.row.id)">{{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}</el-button>
            
            </template>
            </el-table-column>
    </el-table> -->
    <el-table :data="tableData" height="650"
    :row-class-name="tableRowClassName"
    :expand-row-keys="expandedRows"
     row-key="tid"
      border
      style="width: 100%">
    <el-table-column type="expand">
      <template #default="props">
        <el-table :data="props.row.materials" style="min-width: 1600px">
          <el-table-column
          :label="$t('material.id', { msg: 'material.id' })"
          width="50">
          <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
        </el-table-column>
        <el-table-column
          prop="materialCode"
          :label="$t('material.materialcode', { msg: 'material.materialcode' })"
          width="280">
        </el-table-column>
        <el-table-column
          prop="material"
          :label="$t('material.material', { msg: 'material.material' })"
          width="280">
        </el-table-column>
        <el-table-column
          prop="materialPrice"
          :label="$t('material.materialprice', { msg: 'material.materialprice' })"
          width="150">
        </el-table-column>
        <el-table-column
          prop="unit"
          :label="$t('material.unit', { msg: 'material.unit' })"
          width="200">
        </el-table-column>
        <el-table-column
          prop="updateTime"
          :label="$t('craft.updateTime', { msg: 'craft.updateTime' })"
          width="280">
          </el-table-column>
          <el-table-column :label="$t('kbReview.table.opr', { msg: 'kbReview.table.opr' })" width="320" v-if="isAdmin">
            <template #default="scope">
                <el-button
                    size="mini"
                    type="primary" 
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row,props.row.tid)">{{  $t('kbType.update', { msg: 'kbType.update' }) }}</el-button>
                <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index, scope.row.id)">{{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}</el-button>
            
            </template>
            </el-table-column>
        </el-table>
      </template>
    </el-table-column>
    <el-table-column prop="tid" label="id" width="100"></el-table-column>
    <el-table-column prop="materialType" :label="$t('material.mtype', { msg: 'material.mtype' })" width="180"></el-table-column>
    <el-table-column prop="createTime" :label="$t('craft.createTime', { msg: 'craft.createTime' })" width="200"></el-table-column>
    <el-table-column prop="updateTime"  :label="$t('craft.updateTime', { msg: 'craft.updateTime' })" width="200"></el-table-column>
  </el-table>
    <div class="pagination-tools">
            <!--
                background:带背景的页码
                layout：分页条布局
                    prev：上页按钮
                    pager：页码
                    next：下一页按钮
                    sizes:每页显示数量
                    jump：跳转到第几页
                    ->：定位其内容居右显示
                    total：总条目数
                :page-size.sync="pageParam.pageSize":每页条目数   问题1
                :current-page.sync="pageParam.pageNum"：当前页码  问题2
                :page-sizes="pageSizes"：条目列表
                :total="total"：总条目数
                :hide-on-single-page="true":当只有一页时隐藏分页条
            -->
            <el-pagination
                background
                layout="sizes,prev, pager, next,jumper,->,total"
                :page-size="this.pageParam.pageSize"
                :current-page="this.pageParam.pageNum"
                :page-sizes="pageSizes"
                :total="total"
                :hide-on-single-page="false"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :disabled="paginationDisabled"
            >
            </el-pagination>
      </div>  
      <!--添加材料信息  -->
    <el-dialog :title=" $t('material.addmaterial', { msg: 'material.addmaterial' }) " v-model="dialogFormVisible"  width="40%">
    <el-form :model="formInfo" :rules="rules" ref="formInfo" label-width="150px" >
      <el-form-item :label="$t('material.mtype', { msg: 'material.mtype' })" prop="materialType">
        <el-select
          style="width: 100%"
          v-model="formInfo.materialType"
          filterable
          allow-create
          default-first-option
          :placeholder="$t('kbType.parentTips', { msg: 'kbType.parentTips' })">
          <el-option
            v-for="item in parentData"
            :key="item.id"
            :label="item.materialType"
            :value="item.materialType">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  :label="$t('material.materialcode', { msg: 'material.materialcode' })" :label-width="formLabelWidth" prop="materialCode">
        <el-input v-model="formInfo.materialCode" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item  :label="$t('material.material', { msg: 'material.material' })" :label-width="formLabelWidth" prop="material">
        <el-input v-model="formInfo.material" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item  :label="$t('material.materialprice', { msg: 'material.materialprice' })" :label-width="formLabelWidth" prop="materialPrice">
        <el-input v-model="formInfo.materialPrice" autocomplete="off"></el-input>
      </el-form-item>
      <div style="text-align: left;">
      <el-form-item  :label="$t('material.unit', { msg: 'material.unit' })" :label-width="formLabelWidth" prop="currencyId">
        <!-- <el-input v-model="formInfo.unit" autocomplete="off"></el-input> -->
        <el-select v-model="formInfo.currencyId" style="width: 100px;" :placeholder="$t('material.inctips', { msg: 'material.inctips' })">
        <el-option
          v-for="item in currencies"
          :key="item.id"
          :label="item.currency"
          :value="item.id">
        </el-option>
      </el-select>

      <span style="text-align: center; padding-left: 5px; padding-right: 5px;">/</span>

      <el-select v-model="formInfo.weightUnit" style="width: 100px;" placeholder="请选择">
        <el-option
          v-for="item in weightUnits"
          :key="item.id"
          :label="item.unitDenominator"
          :value="item.unitDenominator">
        </el-option>
        </el-select>

      </el-form-item>
      </div>
      <el-form-item >   
      <el-button type="primary" @click="addMaterial('formInfo')" >{{  $t('material.add', { msg: 'material.add' }) }}</el-button>
      <el-button type="success" @click="resetForm('formInfo')">{{ $t('kbinfo.reset', { msg: 'kbinfo.reset' }) }}</el-button>
      <el-button @click="dialogFormVisible = false">{{ $t('kbType.cancel', { msg: 'kbType.cancel' }) }}</el-button> 
      </el-form-item>
    </el-form>  
  </el-dialog>
   <!--修改材料信息  -->
   <el-dialog :title=" $t('material.updatematerial', { msg: 'material.updatematerial' }) " v-model="dialogFormEditor"  width="40%">
    <el-form :model="formEdit" :rules="rules" ref="formEdit" label-width="150px">
      <el-form-item :label="$t('material.mtype', { msg: 'material.mtype' })"  prop="parentId">
       <el-select style="width: 100%" v-model="formEdit.typeId" :placeholder="$t('kbType.parentTip', { msg: 'kbType.parentTip' })">
        <el-option
            v-for="item in parentData"
            :key="item.id"
            :label="item.materialType"
            :value="item.id">
          </el-option>
       </el-select>
      </el-form-item>
      <el-form-item :label="$t('material.materialcode', { msg: 'material.materialcode' })" :label-width="formLabelWidth" prop="materialCode">
        <el-input v-model="formEdit.materialCode" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('material.material', { msg: 'material.material' })" :label-width="formLabelWidth" prop="material">
        <el-input v-model="formEdit.material" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('material.materialprice', { msg: 'material.materialprice' })" :label-width="formLabelWidth" prop="materialPrice">
        <el-input v-model="formEdit.materialPrice" autocomplete="off"></el-input>
      </el-form-item>
      <div style="text-align: left;">
      <el-form-item :label="$t('material.unit', { msg: 'material.unit' })" :label-width="formLabelWidth" prop="unit">
        <!-- <el-input v-model="formEdit.unit" autocomplete="off"></el-input> -->
        <el-select v-model="formEdit.currencyId" style="width: 100px;" :placeholder="$t('material.inctips', { msg: 'material.inctips' })">
        <el-option
          v-for="item in currencies"
          :key="item.id"
          :label="item.currency"
          :value="item.id">
        </el-option>
      </el-select>

      <span style="text-align: center; padding-left: 5px; padding-right: 5px;">/</span>

      <el-select v-model="formEdit.weightUnit" style="width: 100px;" placeholder="请选择">
        <el-option
          v-for="item in weightUnits"
          :key="item.id"
          :label="item.unitDenominator"
          :value="item.unitDenominator">
        </el-option>
        </el-select>

      </el-form-item>
      </div>
      <el-form-item >   
      <el-button type="primary" @click="editMaterial('formEdit')" >{{  $t('kbType.update', { msg: 'kbType.update' }) }}</el-button>
      <el-button @click="dialogFormEditor = false">{{ $t('kbType.cancel', { msg: 'kbType.cancel' }) }}</el-button> 
      </el-form-item>
    </el-form>  
  </el-dialog>

  </template>
  
  <script>
  import { getRequest,postRequest,deleteRequest } from '../../axios/axios';
  import { baseUrl_New } from '../../axios/urlconfig';
    export default {
      data() {
        return {
          tableData: [
            // {id:'1',
            //  materialCode:'FT001',
            //  material:'铝棒',
            //  materialPrice:'4'},
          ],
          pageParam: {//分页参数
          pageNum: 1,//当前页
          pageSize: 5,//每页条目数据
        },
        expandedRows:[1],
        parentData:[],
        total: 0,//总条目数
        pageSizes: [5,10, 20, 30],//每页显示条目数列表
        isAdmin:sessionStorage.role.includes('超级管理员'),
        dialogFormVisible: false,
        currencies: [
        {
            id: '',
            currency: '',
            rate: '',
            abbreviation: '',
            createTime: '',
            updateTime: ''
        }
      ],
      weightUnits: [
        // { id:'1',value: 'kg', label: '千克' },
        // { id:'2',value: 'g', label: '克' },
        // { id:'3',value: 'ton', label: '吨' },
        // { id:'4',value: 'ci', label: '件' },
        // { id:'5',value: 'ge', label: '个' },
        // { id:'6',value: 'm*m', label: '平方米' },
        // { id:'7',value: 'dm*dm', label: '平方分米' },
        // { id:'8',value: 'm*m*m', label: '立方米' },
        // { id:'9',value: 'dm*dm*dm', label: '立方分米' },
        // { id:'10',value: 'tai', label: '台' },
        // { id:'11',value: 'he', label: '盒' },
      ],
        formInfo: {
          materialType:'',
          materialCode: '',
          material: '',
          materialPrice: '',
          unit: '', 
          currencyId:'',
          weightUnit:'千克',
        },
        rules: {
        materialType:[
        { required: true, message: this.$t('material.imtype', { msg: 'material.imtype' }), trigger: 'blur' },
        ],
        materialCode: [
        { required: true, message: this.$t('material.inmctips', { msg: 'material.inmctips' }), trigger: 'blur' },
        ],
        material: [
          { required: true, message: this.$t('material.inmtips', { msg: 'material.inmtips' }), trigger: 'blur' },
        ],
        materialPrice: [
          { required: true, message: this.$t('material.inmptips', { msg: 'material.inmptips' }), trigger: 'blur' },
        ],
        unit: [
          { required: true, message: this.$t('material.inmutips', { msg: 'material.inmutips' }), trigger: 'blur' },
        ],
        currencyId:[
        { required: true, message: this.$t('material.inctips', { msg: 'material.inctips' }), trigger: 'blur' },
        ]
      },
      dialogFormEditor:false,
      formEdit:{
        id:'',
        typeId:'',
        materialCode: '',
        material: '',
        materialPrice: '',
        unit: '',  
        currencyId:'',
        weightUnit:'',
      },
      




        }      
      },

      created(){
        this.getAllList();
        this.getParent();
        this.getCurrencyList();
        this.getUnitList();
       
      },


      methods: {
        getAllList(){//分页查询所有材料
        getRequest(baseUrl_New+'/material/mt/'+ this.pageParam.pageNum + '/' + this.pageParam.pageSize).then(response=>{
          //获得服务器端回传的map对象
          let resultMap = response;
            //从集合中获取用户列表及总条目数
            this.tableData = resultMap.list;
            this.total = resultMap.total;
        })
       },
       handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageParam.pageSize = val;
        this.getAllList();
        },
        handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.pageParam.pageNum = val;
        this.getAllList();
        },
        
        addMaterial(formName){//添加物料信息
        this.$refs[formName].validate((valid) => {
        if (valid) {
          postRequest(baseUrl_New + '/material/add', {
            materialType:this.formInfo.materialType,
            materialCode:this.formInfo.materialCode,
            material:this.formInfo.material,
            materialPrice:this.formInfo.materialPrice,
            //unit:this.formInfo.unit
            currencyId:this.formInfo.currencyId,
            weightUnit:this.formInfo.weightUnit,
          }).then(resp => {
            this.getAllList();
            this.dialogFormVisible= false,
            this.form={},
            this.$message.success(this.$t('material.addoktips', { msg: 'material.addoktips' }));
          }).catch(err => {
            this.$message.error(this.$t('material.adderrtips', { msg: 'material.adderrtips' }));
          })
        } else {
          return false;
        }
      });
        },

      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleDelete(index, id){
        this.$confirm( this.$t('kbReview.deleteMater', { msg: 'kbReview.deleteMater' }), this.$t('issue.tips', { msg: 'issue.tips' }),{
            confirmButtonText: this.$t('addType.confirm', { msg: 'addType.comfirm' }),
            cancelButtonText: this.$t('addType.cancel', { msg: 'addType.cancel' }),
            cancelButtonClass: 'btn-custom-cancel',
            type: 'warning'
        }).then(() => {
            deleteRequest(baseUrl_New + `/material/del/${id}`)
            .then(response=>{
            this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }))
            this.getAllList();
                                 
            })
        })
        },
        handleEdit(index, row,  parentTid){
        this.dialogFormEditor=true;
        this.formEdit = JSON.parse(JSON.stringify(row));
        this.formEdit.typeId =  parentTid;
       },
       editMaterial(formName){ //更新材料信息
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var that = this
        postRequest(baseUrl_New + '/material/update',{
            id:this.formEdit.id,
            typeId:this.formEdit.typeId,
            materialCode:this.formEdit.materialCode,
            material:this.formEdit.material,
            materialPrice:this.formEdit.materialPrice,
            //unit:this.formEdit.unit
            currencyId:this.formEdit.currencyId,
            weightUnit:this.formEdit.weightUnit,
        }).then(resp=>{
          this.getAllList(); 
          this.dialogFormEditor=false;
          this.formEdit={};
          this.$message.success(this.$t('material.updateoktips', { msg: 'material.updateoktips' }));
        }).catch(err => {
          this.$message.error(this.$t('material.updateerrtips', { msg: 'material.updateerrtips' }));
        })
          } else {
            
            return false;
          }
        });
       },
       tableRowClassName({row, rowIndex}) {
        if (rowIndex % 2 === 0) {
          return 'warning-row';
        } else if (rowIndex % 2 === 1) {
          return 'success-row';
        }
        return '';
      },
      getParent() {
      getRequest(baseUrl_New + '/material/get').then(response => {
        //获得服务器端回传的map对象
        let resultMap = response;
        //从集合中获取用户列表及总条目数
        this.parentData = resultMap.list;
      });
    },
     getCurrencyList(){
      getRequest(baseUrl_New + '/rate/list').then(response => {
        //获得服务器端回传的map对象
        let resultMap = response;
        //从集合中获取用户列表及总条目数
        this.currencies = resultMap.list;
      });
     },
     getUnitList(){
      getRequest(baseUrl_New + '/rate/all').then(response => {
        //获得服务器端回传的map对象
        let resultMap = response;
        //从集合中获取用户列表及总条目数
        this.weightUnits = resultMap.list;
      });
     },


      
    }
      
    }
  </script>

<style>
.el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

</style>